import { formatDateYMD } from '@/utils/formatDate'

// A vigência é gravada em dia inteiro no fuso do negócio (início 00:00, fim 23:59:59), então a data
// mostrada deve ser lida em hora local — `iso.slice(0, 10)` mostraria o dia seguinte para o fim.
export const isoToDateValue = (iso: string | null | undefined): string =>
	iso ? formatDateYMD(new Date(iso)) : ''

export const formatLocalDate = (iso: string): string =>
	new Date(iso).toLocaleDateString('pt-BR', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	})
